<template>
  <div
    ref="app-file-upload"
    style="position: relative;"
    @dragover.prevent
    @dragenter.prevent="dragEnter"
    @dragleave.prevent="dragLeave"
    @drop.prevent="dropFile"
    @click="uploadFileInit"
  >
    <div v-show="dragOver" class="drag-over">
      <div class="center-center">
        DROP FILE
      </div>
    </div>

    <input
      ref="uploadFileInput"
      v-show="!Files[0]"
      type="file"
      :multiple="multiple"
      @change="startUpload"
    />
    <slot>
      <v-btn :disabled="disabled" class="px-2"
        >{{ text }}
        <div v-if="loading" class="loading">
          <v-progress-linear
            color="blue-grey lighten-3"
            indeterminate
            rounded
            height="6"
          ></v-progress-linear>
        </div>
      </v-btn>
    </slot>
    <!-- SHOWS FILE UPLOADS IF PROP IS SET TO TRUE -->
    <div v-if="uploadArray.length > 0 && showUploads">
      Files to Upload
      <ul v-for="(file, index) in uploadArray" :key="index">
        <li>{{ file.name }} - status: {{ progress[index] }}</li>
      </ul>
    </div>
  </div>
</template>

<script>
/* eslint-disable */
import SaninnLogger from "@/config/debugger";
const debug = new SaninnLogger("AppFileUpload.vue", true);

import firebase from "firebase/app";
const config = {
  refDirectory: "fileUploads", // where files will be stored
  sizes: {
    // matches firebase resize extension
    thumbnail: "200x200",
    md: "800x600",
    lg: "1200x800",
  },
};
export default {
  name: "AppFileUpload",
  props: {
    multiple: {
      default: false,
      type: Boolean,
    },
    folder: {
      default: "uploaded-files",
      type: String,
    },
    text: {
      type: String,
      default: "Upload File",
    },
    showUploads: {
      type: Boolean,
      default: false,
    },
    disabled: {
      type: Boolean,
    },
  },
  data() {
    return {
      Files: [],
      dragOver: false,
      gotFile: false,
      progress: [],
      acceptedFiles: ["jpg", "png", "jpeg", "zip", "gif", "pdf"],
      currentFiles: [],
      uploadArray: [],
      dragVariable: 0, // used to prevent flickering
      loading: false,
    };
  },
  watch: {
    progress(newVal) {
      // CHECKS IF ALL DOWNLOADS ARE COMPLETE
      let complete = this.progress.every((v) => v == 100); // checks if all file download progress is 100
      console.log("complete", complete);
      console.log("newVal", newVal);
      if (complete && newVal.length != 0) {
        // newVal included to prevent infinite loop
        console.log("Downloads Complete Create Call back");
        this.$emit("callback");
        this.loading = false;
        setTimeout(this.reset, 2500); // resets component
      }
    },
  },
  methods: {
    // #region // METHODS TO PREVENT DRAG OVER EVENT FROM FLICKERING
    dragEnter(e) {
      e.preventDefault();

      this.dragVariable++;

      this.dragOver = true;
    },
    dragLeave() {
      this.dragVariable--;
      if (this.dragVariable === 0) {
        this.dragOver = false;
      }
    },
    // #endregion
    dropFile(e) {
      e.preventDefault();
      // UPLOAD VIA DRAG
      this.dragVariable = 0;
      this.dragOver = false;
      debug.log("drag.file", e.dataTransfer.files);
      this.startUpload(e);
    },
    startUpload(e) {
      const _this = this;
      var files = e.target.files || e.dataTransfer.files;
      console.log("startUpload:files", files);

      // check if multiple files are acceptable
      if (!this.multiple && files.length > 1) {
        this.$app.alert({
          snackbar: true,
          text: "Upload only accepts a single file please",
          timeout: 5000, // any integer in ms
          color: "#ff0000",
          mode: null, // vertical / multi-line default: null
          x: null, // left / right
          y: "top", // top / bottom
          dark: true,
        });
        this.reset();
        return;
      }

      if (!files.length) {
        files = null;
        // TODO: no files available ACTION
        return;
      }
      for (var i = 0; i < files.length; i++) {
        // creates files
        this.createFile(files[i]);
      }
    },
    createFile(file) {
      const _this = this;
      // FORMATS NAME AND CHECK FOR ACCEPTABLE FILE EXTENSION
      const acceptedFiles = this.acceptedFiles;
      const currentFiles = this.currentFiles; // current files of property
      file.filename = file.name
        .normalize("NFD")
        .replace(/[\u0300-\u036f]/g, ""); // changes all french accents to non-accent letters
      file.filename = file.name
        .replace(/[&\/\\#,+()$~%'":*?<>{}\s]/g, "_")
        .normalize("NFD")
        .replace(/[\u0300-\u036f]/g, ""); // format filename remove spaces and special characters
      file.extension = file.name
        .split(".")
        .pop()
        .toLowerCase();

      // CHECK IF FILENAME ALREADY EXISTS IN ARRAY
      function checkileExists(name) {
        // checks if filname already exists
        return currentFiles.some(function(file) {
          return file.name === name;
        });
      }

      if (checkileExists(file.filename)) {
        // TODO: DO SOMETHING IF FILENAME ALRADY EXITS
        debug.log("FILE NAME EXISTS: " + file.filename);
        // this.alert = {
        //   show: true,
        //   closeBtn: true,
        //   position: { vertical: "top", horizontal: "center" },
        //   color: "red",
        //   timeout: 4000,
        //   message: `${file.filename} already exists.  Change name and try and upload again`,
        // };
        // _this.file = ""; // removes file
        // _this.dragging = false; // resets download area
        return;
      }

      // check for acceptable file extension
      if (acceptedFiles.indexOf(file.extension.toLowerCase()) === -1) {
        debug.log("Not acceptable file type: " + file.name);
        // create alert here
        return;
      }
      // check file size
      if (file.size > 5000000) {
        debug.log("please check file size no over 5 MB.");

        return;
      }
      this.uploadFile(file);
    },
    uploadFile(file) {
      this.loading = true;
      debug.log("upload file", file);
      const _this = this;
      const refDirectory = config.refDirectory;

      let uploadArray = this.uploadArray;
      let index = uploadArray.length; // indicates index
      uploadArray.push(file);

      var storageRef = firebase.storage().ref(config.refDirectory);
      //Upload file task - where folder is the property id
      var uploadTask = storageRef
        .child(_this.folder + "/" + file.filename)
        .put(file);
      //Update progress bar
      uploadTask.on(
        "state_changed",
        function(snapshot) {
          var percentage = Math.round(
            (snapshot.bytesTransferred / snapshot.totalBytes) * 100
          );

          _this.$set(_this.progress, index, percentage); // updates progress using set to make it reactive
          // _this.progress[index] = percentage; - DOES NOT WORK
          debug.log("percentage", _this.progress[index]);
        },
        function error(err) {
          debug.log("upload error");
        },
        function() {
          // UPLOAD COMPLETE
          //_this.progress[index] = 100;
          console.log("upload complete", _this.uploadArray);

          //_this.getResizedImageData(file, index);

          // Gets download URL of uploaded file
          // uploadTask.snapshot.ref
          //   .getDownloadURL()
          //   .then(function(downloadURL) {
          //     debug.log("File available at", downloadURL, _this);
          //   });
        }
      );
    },
    reset() {
      this.progress = [];
      this.currentFiles = [];
      this.uploadArray = [];
    },
    uploadFileInit() {
      this.$refs.uploadFileInput.click();
      //this.Files = e.target.files;
      //console.log("uploadFile", this.Files);
    },
  },
};
</script>

<style scoped>
input[type="file"] {
  display: none;
}
.drag-over {
  position: absolute;
  display: block;
  height: 100%;
  width: 100%;

  background: gray;
  outline: 2 px dashed #92b0b3;
  /* outline-offset: -5 px; */
  z-index: 5;
}
.loading {
  display: inline-block;
  height: 80%;
  width: 100%;
  position: absolute;
  left: 0;
  bottom: -0.9rem;
}
</style>
